import { IsoCountryCode } from 'generated/rbi-graphql';
import { firstDataUrlTh } from 'utils/environment';

import { INTL_LOCAL_DEV_FD_PROXY_URL } from './constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getFdProxyAndUrl = (country?: IsoCountryCode) => [
  INTL_LOCAL_DEV_FD_PROXY_URL,
  firstDataUrlTh,
];
